import * as React from "react";
import { forwardRef } from "react";
const SvgSortAlphaDesc = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 800, height: 800, fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "rgba(255,255,255,0.5)", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M7 3v18M7 3l4 4M7 3 3 7m12.5 7h5l-5 7h5M16 9h4m-5 1 3-7 3 7" }));
const ForwardRef = forwardRef(SvgSortAlphaDesc);
export { ForwardRef as ReactComponent };
